<template>
  <div class="discounts grid grid-cols-5 gap-4 p-6 lg:pt-8 rounded-3xl">
    <div class="mx-auto hidden lg:block">
      <svg
        width="115"
        height="77"
        viewBox="0 0 115 77"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M72.0405 11.0196L89.8011 10.7757C92.491 10.7399 97.1463 13.5015 98.7029 15.6606L107.806 28.3068C110.576 32.2254 112.079 36.8997 112.109 41.6989V55.9591C112.096 57.2506 111.577 58.4855 110.664 59.3987C109.751 60.312 108.516 60.8309 107.225 60.8439H96.6944"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M74.8744 60.8359H39.6976"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.2453 60.844H8.02201C6.73052 60.8309 5.4956 60.3121 4.58233 59.3988C3.66906 58.4855 3.15019 57.2506 3.13712 55.9591V28.7803"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 15.2443V8.01378C3.01307 6.72229 3.53192 5.48737 4.44519 4.5741C5.35847 3.66083 6.59338 3.14198 7.88488 3.12891H35.0565"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M35.0569 3.12891H67.1566C68.4481 3.14198 69.683 3.66083 70.5962 4.5741C71.5095 5.48737 72.0284 6.72229 72.0415 8.01378V15.2443"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M85.7771 52.4082C87.9398 52.4068 90.0544 53.0469 91.8532 54.2476C93.652 55.4482 95.0543 57.1555 95.8826 59.1533C96.7109 61.1511 96.928 63.3497 96.5064 65.4709C96.0848 67.5922 95.0435 69.5407 93.5142 71.07C91.9849 72.5992 90.0364 73.6405 87.9152 74.0621C85.794 74.4837 83.5954 74.2666 81.5976 73.4383C79.5997 72.61 77.8925 71.2077 76.6918 69.4089C75.4912 67.6101 74.8511 65.4956 74.8525 63.3328C74.8525 60.4354 76.0035 57.6567 78.0522 55.608C80.101 53.5592 82.8797 52.4082 85.7771 52.4082Z"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.6792 52.4082C28.8419 52.4068 30.9565 53.0469 32.7553 54.2476C34.5541 55.4482 35.9564 57.1555 36.7847 59.1533C37.613 61.1511 37.8301 63.3497 37.4085 65.4709C36.9869 67.5922 35.9456 69.5407 34.4163 71.07C32.887 72.5992 30.9385 73.6405 28.8173 74.0621C26.6961 74.4837 24.4974 74.2666 22.4996 73.4383C20.5018 72.61 18.7946 71.2077 17.5939 69.4089C16.3933 67.6101 15.7532 65.4956 15.7546 63.3328C15.7546 61.8982 16.0371 60.4776 16.5862 59.1522C17.1352 57.8267 17.9399 56.6224 18.9543 55.608C19.9688 54.5935 21.1731 53.7888 22.4985 53.2398C23.8239 52.6908 25.2445 52.4082 26.6792 52.4082V52.4082Z"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M72.0413 13.1064V33.808C72.0227 35.0978 71.5021 36.3295 70.59 37.2416C69.6779 38.1537 68.4461 38.6743 67.1564 38.6929H7.92095C6.62888 38.6816 5.3929 38.1634 4.47923 37.2497C3.56556 36.336 3.04731 35.1001 3.03607 33.808V13.1064"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M111.866 38.0904H89.3714C88.0795 38.081 86.8432 37.5631 85.9303 36.6488C85.0173 35.7346 84.5013 34.4975 84.4937 33.2055V11.2559"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.679 61.044C27.1333 61.044 27.5774 61.1788 27.955 61.4313C28.3326 61.6838 28.6268 62.0428 28.8003 62.4626C28.9739 62.8825 29.0189 63.3443 28.9297 63.7898C28.8406 64.2353 28.6213 64.6442 28.2995 64.965C27.9778 65.2857 27.5681 65.5037 27.1224 65.5915C26.6767 65.6793 26.2149 65.6328 25.7956 65.4579C25.3763 65.2831 25.0183 64.9878 24.767 64.6094C24.5156 64.231 24.3822 63.7865 24.3836 63.3322C24.3836 63.0311 24.443 62.7329 24.5585 62.4548C24.6739 62.1768 24.8431 61.9242 25.0563 61.7116C25.2696 61.499 25.5227 61.3307 25.8011 61.2161C26.0796 61.1015 26.3779 61.043 26.679 61.044V61.044ZM85.7781 61.044C86.2324 61.044 86.6765 61.1788 87.0541 61.4313C87.4317 61.6838 87.7259 62.0428 87.8995 62.4626C88.073 62.8825 88.118 63.3443 88.0289 63.7898C87.9397 64.2353 87.7204 64.6442 87.3987 64.965C87.0769 65.2857 86.6673 65.5037 86.2215 65.5915C85.7758 65.6793 85.3141 65.6328 84.8947 65.4579C84.4754 65.2831 84.1174 64.9878 83.8661 64.6094C83.6147 64.231 83.4813 63.7865 83.4827 63.3322C83.4827 63.0311 83.5422 62.7329 83.6576 62.4548C83.773 62.1768 83.9422 61.9242 84.1555 61.7116C84.3687 61.499 84.6218 61.3307 84.9003 61.2161C85.1787 61.1015 85.477 61.043 85.7781 61.044V61.044Z"
          stroke="white"
          stroke-width="4.7199"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="col-span-5 md:col-span-3 -ml-1">
      <p
        class="text-center text-white font-bold text-2xl"
        v-html="discountHeader"
      ></p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props  = defineProps({
  discountHeader: {
    type: String,
    required: true,
  },
});
</script>


<style scoped>
.discounts {
  background: linear-gradient(180deg, #4da43a 0%, #25590b 100%);
  color: #ffffff;
}

h1,
h2,
h3,
h4,
h5 {
  font-style: normal;
  text-align: center;
}

.discount-button {
  background: #ffffff;
  color: #00810e;
}
</style>
